import React, { useState } from 'react'
import axios from '../../../library/axios'
import { MySwal } from '../../../library/swal'
import Button from 'react-bootstrap/Button'
import SelectUsers from 'react-select';
import SelectGroups from 'react-select';
import SelectModules from 'react-select';
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';

const EditMapingGroupComp = (props) => {
    // console.log(props?.mapingGroup)

    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)

    const [idGroup, setidGroup] = useState(
        {
            value: props?.mapingGroup?.group?.id,
            label: props?.mapingGroup?.group?.namaGroup,
        }
    )
    const [idModule, setidModule] = useState(
        {
            value: props?.mapingGroup?.module?.id,
            label: props?.mapingGroup?.module?.namaModule,
        }
    )
    const [idUser, setidUser] = useState(
        {
            value: props?.mapingGroup?.user?.id,
            label: props?.mapingGroup?.user?.namaLengkap,
        }
    )

    const handleEdit = () => {
        setLoading(true)
        setDisabled(true)

        const requestBody = {
            idGroups: idGroup?.value,
            idModules: idModule?.value,
            idUser: idUser?.value,
        }
        // console.log(requestBody)
        // return false
        axios({
            url: `/mapping-groups/update/${props?.mapingGroup?.id}`,
            method: 'PATCH',
            data: requestBody,
            headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
            .then(res => {
                // console.log(res)
                // return false
                if (res.status === 200) {
                    MySwal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Successfully updated Maping Group!'
                    })

                    setLoading(false)
                    setDisabled(false)

                    props.close()
                    props.fetch()
                }
            })
            .catch(err => {
                setLoading(false)
                setDisabled(false)
                if (err !== "") {
                    console.log(err?.response?.data?.message)
                    MySwal.fire({
                        icon: 'error',
                        title: 'Oops, Error!',
                        text: getApiErrorMessage(err)
                    })
                }
            })
    }

    return (
        <div>
            <div className="mb-3 row">
                <label htmlFor="user" className="col-sm-2 col-form-label required">Users</label>
                <div className="col-12">
                    <SelectUsers
                        id='user'
                        value={idUser}
                        onChange={setidUser}
                        options={props.users}
                        placeholder='Cari users'
                    />
                </div>
            </div>
            <div className="mb-3 row">
                <label htmlFor="group" className="col-sm-2 col-form-label required">Groups</label>
                <div className="col-12">
                    <SelectGroups
                        id='group'
                        value={idGroup}
                        onChange={setidGroup}
                        options={props.groups}
                        placeholder='Cari groups'
                    />
                </div>
            </div>
            <div className="mb-3 row">
                <label htmlFor="module" className="col-sm-2 col-form-label required">Modules</label>
                <div className="col-12">
                    <SelectModules
                        id='module'
                        value={idModule}
                        onChange={setidModule}
                        options={props.modules}
                        placeholder='Cari modules'
                    />
                </div>
            </div>
            <div className="mt-5 row">
                <div className="col-12">
                    <Button variant="danger" size="sm" onClick={() => props.close()}>
                        Tutup
                    </Button>
                    &nbsp;
                    <Button disabled={disabled} variant="success" size="sm" onClick={() => handleEdit()}>{loading === true ? 'Mohon Tunggu..' : 'Simpan'}</Button>
                </div>
            </div>
        </div>
    )
}

export default EditMapingGroupComp
